module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('span', {
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "id": "copyright-link"
    }
  }, [_c('icon', {
    attrs: {
      "name": "copyright",
      "scale": "1"
    }
  }), _vm._v(" 2017 " + _vm._s(_vm.studio308.name) + "\n    ")], 1), _vm._v(" -\n  ")], 1), _vm._v(" "), _c('a', {
    staticClass: "scroll-top pointer easy",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("TOP "), _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("↑")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60de58f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 919
// module chunks = 1